"use strict";

define('model/filter',['datakit/model'], function (Model) {
  var Filter = Model.extend({});
  return Filter;
});

